<template>
  <svg
    :class="[name]"
    :width="viewWidth"
    :height="viewHeight"
    :viewBox="`0 0 ${viewWidth} ${viewHeight}`"
  >
    <circle
      v-for="(dot, index) in dots"
      :key="index"
      :cx="dot.cx"
      :cy="dot.cy"
      :r="dot.radius"
      fill="currentColor"
      :opacity="Math.random() * (1 - 0.2) + 0.2"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default() {
        return 6
      },
    },
    height: {
      type: Number,
      default() {
        return 6
      },
    },
    space: {
      type: Number,
      default() {
        return 57
      },
    },
  },
  data() {
    return {
      name: 'a-svg-dots',
      radius: 1.5,
      dots: [],
    }
  },
  computed: {
    viewWidth() {
      return (
        this.width * this.radius * 2 +
        (this.width - 1) * (this.space - this.radius * 2)
      )
    },
    viewHeight() {
      return (
        this.height * this.radius * 2 +
        (this.height - 1) * (this.space - this.radius * 2)
      )
    },
  },
  created() {
    this.createBox()
  },
  methods: {
    createBox() {
      for (let indexWidth = 0; indexWidth < this.width; indexWidth++) {
        for (let indexHeight = 0; indexHeight < this.height; indexHeight++) {
          this.dots.push({
            cx: this.radius + indexWidth * this.space,
            cy: this.radius + indexHeight * this.space,
            radius: this.radius,
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
